import Badge from '@codegouvfr/react-dsfr/Badge';
import { createModal } from '@codegouvfr/react-dsfr/Modal';
import { getBadgeSeverityByStatutOrganisme, ORGANISME_STATUS_STYLES } from '@common/config';
import { OrganismeDetailsDto } from '@common/services';
import { ContactButton, ContactModal } from '@common/ui';
import { DateUtils } from '@common/utils';
import React from 'react';

const contactModal = createModal({
  id: 'contact-modal',
  isOpenedByDefault: false,
});

export const MyOfaHeader = ({ organisme }: MyOfaHeaderProps) => {
  return (
    <div className={'flex flex-col gap-4'}>

      <div className={'flex gap-4'}>

        <div className={'flex flex-col flex-1 gap-1'}>

          <div className={'flex gap-4'}>

            <h5 style={{ marginBottom: 0 }}>{organisme.raisonSociale} - Données de l'organisme</h5>

            <div className={'flex'}>
              <Badge severity={getBadgeSeverityByStatutOrganisme(organisme.statut)}>
                {ORGANISME_STATUS_STYLES[organisme.statut].text}
              </Badge>
            </div>
          </div>

          <span>Mise à jour le {DateUtils.formatForOfaDetailsMessage(organisme.dateStatutModification || organisme.dateCreation)}</span>
        </div>

        <div>
          <ContactButton label="contacter france compétences" onClick={() => contactModal.open()} />
        </div>
      </div>

      <ContactModal dsfrModal={contactModal} />
    </div>
  );
};

interface MyOfaHeaderProps {
  organisme: OrganismeDetailsDto;
}